import request from '@/utils/request'

// 分页查询车辆品牌列表
export function getVehicleBrandPage(params) {
  return request({
    url: '/api/admin/vehicle-brand/page',
    method: 'get',
    params
  })
}

// 获取所有车辆品牌选项
export function getVehicleBrandOptions() {
  return request({
    url: '/api/admin/vehicle-brand/options',
    method: 'get'
  })
}

// 根据ID查询车辆品牌详情
export function getVehicleBrandById(id) {
  return request({
    url: `/api/admin/vehicle-brand/${id}`,
    method: 'get'
  })
}

// 新增车辆品牌
export function addVehicleBrand(data) {
  return request({
    url: '/api/admin/vehicle-brand',
    method: 'post',
    data
  })
}

// 更新车辆品牌
export function updateVehicleBrand(id, data) {
  return request({
    url: `/api/admin/vehicle-brand/${id}`,
    method: 'put',
    data
  })
}

// 删除车辆品牌
export function deleteVehicleBrand(id) {
  return request({
    url: `/api/admin/vehicle-brand/${id}`,
    method: 'delete'
  })
}

// 批量删除车辆品牌
export function batchDeleteVehicleBrand(ids) {
  return request({
    url: '/api/admin/vehicle-brand/batch',
    method: 'delete',
    data: ids
  })
}
